import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import TextBox from 'components/controls/TextBox';
import CircularProgress from 'components/CircularProgress';
import { showMessage, handleHTTPError } from 'store/actions';
import { forgotPassword } from 'apis';
import './index.scss';

class ForgotPass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            validate: false,
            loading: false,
        };
    }

    forgotPass = async () => {
        if (this.state.loading) return;
        this.setState({ validate: true });
        if (!this.state.email) return;
        try {
            this.setState({ loading: true });
            const params = { email: this.state.email };
            const { message } = await forgotPassword(params);
            this.props.showMessage({ show: true, message: { text: message, type: 'success' } });
            this.props.history.push(`/resetpass?email=${this.state.email}`);
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        return (
            <div className="forgotpass-wrapper">
                <div className="content border shadow bg-white text-center">
                    <div className="logo">
                        <img src="/images/logo/logo_green.png" alt="" style={{ maxWidth: '250px' }} />
                    </div>
                    <h1 className="mt-3 mb-4 font-weight-bold">Forgot Password</h1>
                    <TextBox
                        label="Email Address"
                        id="email"
                        name="email"
                        type="text"
                        required
                        className="mb-4 text-left"
                        validate={this.state.validate}
                        value={this.state.email}
                        placeholder="youremail@mail.com"
                        onBlur={(e) => {}}
                        onChange={(email, e) => {
                            this.setState({ email });
                        }}
                        validationOption={{
                            showMsg: false,
                            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            check: true,
                            required: true,
                        }}
                    />
                    <Button
                        color="primary"
                        className="mt-4"
                        size="lg"
                        style={{ width: '200px' }}
                        onClick={this.forgotPass}
                    >
                        Submit
                    </Button>
                    <p
                        className="text-primary linkbtn text-center mt-4"
                        onClick={() => {
                            this.props.history.push('/');
                        }}
                    >
                        Try login again
                    </p>
                    {this.state.loading && (
                        <div className="loader-view">
                            <CircularProgress />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default connect(null, {
    showMessage,
    handleHTTPError,
})(ForgotPass);
